import { SaiposTableConfiguration } from "@/core/SaiposTableConfiguration";
import { useEffect, useState } from "react";


export function useSaiposTableConfiguration() {
  const [configurations, setConfigurations] = useState({});

  const isValid =
    configurations?.externalId &&
    configurations?.idPartner &&
    configurations?.codStore;

  useEffect(() => {
    const tableConfigurations = SaiposTableConfiguration.fromStorage();

    setConfigurations(tableConfigurations);

    tableConfigurations.addListener(() => {
      const updatedTableConfigurations =
        SaiposTableConfiguration.fromStorage();
      setConfigurations(updatedTableConfigurations);
    });

    return () => tableConfigurations.removeListener();
  }, []);

  const persistConfigurations = () => {
    const tableConfigurations = SaiposTableConfiguration.fromStorage();
    tableConfigurations.update(configurations);
  };

  const updateConfigurations = (newConfigurations) => {
    if (newConfigurations === null) {
      setConfigurations(null);
    } else {
      setConfigurations({
        ...configurations,
        ...newConfigurations,
      });
    }
  };

  return [configurations, updateConfigurations, persistConfigurations, isValid];
}
